import React, { useState } from 'react';
import { Popup } from 'devextreme-react';
import NotificationList from './NotificationList';
import NotificationBadge from './NotificationBadge';
import './NotificationModal.scss';

const NotificationModal = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleModal = () => {
    setIsVisible(!isVisible);
  };

  const closeModal = () => {
    setIsVisible(false);
  };

  return (
    <>
      <NotificationBadge onClick={toggleModal} />
      
      <Popup
        visible={isVisible}
        onHiding={closeModal}
        title="Benachrichtigungen"
        width={400}
        height={500}
        showCloseButton={true}
        dragEnabled={false}
        className="notification-modal"
      >
        <NotificationList />
      </Popup>
    </>
  );
};

export default NotificationModal;
